import { any } from 'prop-types';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  MovimentacaoListaEnum,
  StatusEnvioListaEnum,
  StatusExecucaoEnum,
  StatusListaAPIEnum,
} from '../enums';

import history from '../services/history';

import 'react-toastify/dist/ReactToastify.css';
import { WarningToast } from '../components/molecules/Toast';

import { Creators as ListaActions } from '../store/ducks/lista';

import modeloImportarLote from '../assets/modelos/LAYREPAS_007_CONTRATANTE.txt';
import modeloImportarLoteCsv from '../assets/modelos/PlanilhaModeloCsv.xlsx';
import modeloImportarLoteNestle from '../assets/modelos/PlanilhaModeloNestlé.xlsx';
import modeloImportarLoteTransferencia from '../assets/modelos/Transferencia/TransferenciaModeloPadrao.xlsx';

import useSignalR from './useSignalR';

const useMovimentacao = (usuario) => {
  const dispatch = useDispatch();
  const { postImportarLote, postImportarLoteCsv } = useSelector(
    (state) => state.lista
  );
  const [BuildConnection, OpenConnection, CloseConnection, connection] =
    useSignalR();
  // #region  Métodos para Importacao antes do carregamento dos arquivos
  const setContentText = (acao) => {
    const acoes = {
      [MovimentacaoListaEnum.returnIdForName.Lote]: (
        <>
          Realize o envio de
          <strong> listas de movimentações em lote </strong>
          através do envio de até <strong>10</strong> arquivos
          <strong>.txt </strong>
          de até <strong> 5mb</strong> cada.
        </>
      ),
      [MovimentacaoListaEnum.returnIdForName['Lote-csv']]: (
        <>
          Realize o envio de
          <strong> listas de movimentações em lote </strong>
          através do envio de até <strong>10</strong> arquivos
          <strong>.csv </strong>
          de até <strong> 5mb</strong> cada.
        </>
      ),
      [MovimentacaoListaEnum.returnIdForName.Nestle]: (
        <>
          Realize o envio de
          <strong> listas de movimentações em lote </strong>
          através do envio de <strong>1</strong> arquivo com extensão
          <strong> (xls, xlsx e xlsm) </strong>
          com até <strong>10mb</strong>.
        </>
      ),
      [MovimentacaoListaEnum.returnIdForName.Inclusao]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Alteração]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Exclusão]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Transferencia]: (
        <>
          Para a<strong> criação </strong>
          de uma <strong>nova lista de transferência</strong> é necessário o
          <strong> anexo do arquivo .xls ou .xlsx </strong>
          de até <strong> 2mb</strong> com os dados dos beneficiários.
        </>
      ),
    };

    return acoes[acao];
  };

  const setModeloPadrao = (acao) => {
    const acoes = {
      [MovimentacaoListaEnum.returnIdForName.Lote]: {
        nomeArquivo: 'modelo-padrão-layout07.txt',
        path: modeloImportarLote,
      },
      [MovimentacaoListaEnum.returnIdForName['Lote-csv']]: {
        nomeArquivo: 'modelo-padrão-csv.xlsx',
        path: modeloImportarLoteCsv,
      },
      [MovimentacaoListaEnum.returnIdForName.Nestle]: {
        nomeArquivo: 'planilha-modelo-padrão.xlsx',
        path: modeloImportarLoteNestle,
      },
      [MovimentacaoListaEnum.returnIdForName.Inclusao]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Alteração]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Exclusão]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Transferencia]: {
        nomeArquivo: 'modelo-padrão-transferencia.xlsx',
        path: modeloImportarLoteTransferencia,
      },
    };

    return acoes[acao];
  };

  const setValidacao = (acao) => {
    const acoes = {
      [MovimentacaoListaEnum.returnIdForName.Lote]: {
        maxSizeFiles: 5242880,
        maxQuantityFiles: 10,
        validExtension: ['txt'],
      },
      [MovimentacaoListaEnum.returnIdForName['Lote-csv']]: {
        maxSizeFiles: 10485760,
        maxQuantityFiles: 10,
        validExtension: ['csv'],
      },
      [MovimentacaoListaEnum.returnIdForName.Nestle]: {
        maxSizeFiles: 10485760,
        maxQuantityFiles: 1,
        validExtension: ['xls', 'xlsx', 'xlsm'],
      },
      [MovimentacaoListaEnum.returnIdForName.Inclusao]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Alteração]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Exclusão]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Transferencia]: {
        maxSizeFiles: 2097152,
        maxQuantityFiles: 10,
        validExtension: ['xls', 'xlsx'],
      },
    };

    return acoes[acao];
  };

  const setDispatch = (acao) => {
    const acoes = {
      [MovimentacaoListaEnum.returnIdForName.Lote]:
        ListaActions.importarLoteRequest,
      [MovimentacaoListaEnum.returnIdForName['Lote-csv']]:
        ListaActions.validarLoteCsvRequest,
      [MovimentacaoListaEnum.returnIdForName.Nestle]:
        ListaActions.postArquivoImportacaoNestleRequest,
      [MovimentacaoListaEnum.returnIdForName.Inclusao]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Alteração]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Exclusão]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Transferencia]:
        ListaActions.importarLoteRequest,
    };

    return acoes[acao];
  };

  const setParams = useCallback(
    (acao) => {
      const acoes = {
        [MovimentacaoListaEnum.returnIdForName.Lote]: {
          codigoContratante: usuario?.codigoContratante,
          TipoLista: MovimentacaoListaEnum.returnName[5],
        },
        [MovimentacaoListaEnum.returnIdForName['Lote-csv']]: {
          codigoContratante: usuario?.codigoContratante,
          TipoLista: MovimentacaoListaEnum.returnName[5],
          idUsuarioLogado: usuario?.idUsuarioLogado,
        },
        [MovimentacaoListaEnum.returnIdForName.Inclusao]: (_) => _,
        [MovimentacaoListaEnum.returnIdForName.Alteração]: (_) => _,
        [MovimentacaoListaEnum.returnIdForName.Exclusão]: (_) => _,
        [MovimentacaoListaEnum.returnIdForName.Transferencia]: {
          codigoContratante: usuario?.codigoContratante,
          TipoLista: MovimentacaoListaEnum.returnName[4],
        },
      };

      return acoes[acao];
    },
    [usuario]
  );

  const handleFiles = useCallback(
    async (acao, newFiles, callback) => {
      if (newFiles && newFiles.length > 0) {
        const conn = await BuildConnection('ProgressStatusHub');
        await OpenConnection(conn);
        const params = {
          ...(!!setParams(acao) && setParams(acao)),
          newFiles,
          connection: conn,
        };
        dispatch(setDispatch(acao)(params));
        callback();
      }
    },
    [BuildConnection, setParams, OpenConnection, dispatch]
  );

  const setErrors = (acao) => {
    const acoes = {
      [MovimentacaoListaEnum.returnIdForName.Lote]: (errors) =>
        getErrors(errors, setValidacao(acao)),
      [MovimentacaoListaEnum.returnIdForName['Lote-csv']]: (errors) =>
        getErrors(errors, setValidacao(acao)),
      [MovimentacaoListaEnum.returnIdForName.Nestle]: (errors) =>
        getErrors(errors, setValidacao(acao)),
      [MovimentacaoListaEnum.returnIdForName.Inclusao]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Alteração]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Exclusão]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Transferencia]: (errors) =>
        getErrors(errors, setValidacao(acao)),
    };

    return acoes[acao];
  };

  const getErrors = ({ fileErrors, hasMaxQuantity }, validation) => {
    if (validation?.maxQuantityFiles && hasMaxQuantity) {
      toast.error(
        <WarningToast>
          Somente podem ser enviados {validation.maxQuantityFiles} arquivos por
          lote.
        </WarningToast>
      );
    }

    if (fileErrors.length > 0) {
      fileErrors.forEach((error) => {
        if (validation?.maxSizeFiles && error.error.hasMaxSize) {
          toast.error(
            <WarningToast>
              O arquivo <strong>{error.name}</strong> é maior que o tamanho
              permitido.
            </WarningToast>
          );
        }
        if (
          validation?.validExtension &&
          validation?.validExtension.length > 0 &&
          error.error.hasValidExtension
        ) {
          toast.error(
            <WarningToast>
              O arquivo <strong>{error.name}</strong> não possui extensão
              válida.
            </WarningToast>
          );
        }
      });
    }
  };
  // #endregion

  // #region  Métodos para Importacao durante/pós carregamento dos arquivos
  const setAfterLoading = (acao, callback, user) => {
    const acoes = {
      [MovimentacaoListaEnum.returnIdForName.Lote]: () => {
        dispatch(ListaActions.importarLoteUpdateFiles());
        history.push('/novo/lista/importar-lote');
      },
      [MovimentacaoListaEnum.returnIdForName['Lote-csv']]: () => {
        sendToCsv(postImportarLote.files, user);
      },
      [MovimentacaoListaEnum.returnIdForName.Nestle]: () => {
        dispatch(ListaActions.importarLoteUpdateFiles());
        callback();
      },
      [MovimentacaoListaEnum.returnIdForName.Inclusao]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Alteração]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Exclusão]: (_) => _,
      [MovimentacaoListaEnum.returnIdForName.Transferencia]: () => {
        dispatch(ListaActions.importarLoteUpdateFiles());
        history.push('/novo/lista/importar-lote');
      },
    };

    return acoes[acao];
  };

  const handleDeleteFiles = (newFiles) => {
    if (!Array.isArray(newFiles)) newFiles = [newFiles];

    dispatch(ListaActions.deleteListaRequest(newFiles));
  };
  // #endregion

  // #region Métodos para o Lobby de Listas (Listas detalhe)
  const setTipoEnvio = (tipo, acao, files) => {
    const tipos = {
      [StatusEnvioListaEnum.returnIdForName.Processamento]: {
        [MovimentacaoListaEnum.returnIdForName.Transferencia]:
          sendToProcessamento,
        [MovimentacaoListaEnum.returnIdForName.Lote]: sendToProcessamento,
      },
      [StatusEnvioListaEnum.returnIdForName.Validacao]: {
        [MovimentacaoListaEnum.returnIdForName.Lote]: sendToValidacao,
        [MovimentacaoListaEnum.returnIdForName.Transferencia]:
          sendValidacaoTransferencia,
      },
    };

    return acao && tipos[tipo][acao](files);
  };

  const setDescricao = (files, data, callback) => {
    const newLista = [];
    files.map((file) => {
      const { descricao, ...newFile } = file;

      const newDescricao = data.descricao[file.idLista];

      if (newDescricao !== file.descricao) {
        newLista.push({
          ...newFile,
          idLista: file.idLista,
          descricao: newDescricao,
        });
      }
    });

    if (newLista.length > 0) {
      dispatch(ListaActions.putListasRequest(newLista));
      callback();
    }

    return newLista;
  };

  const sendToValidacao = (files) => {
    const newFiles = files.map((file) => {
      return {
        idLista: file.idLista,
        statusLista: StatusListaAPIEnum.returnId.EmValidacao,
        statusExecucao: StatusExecucaoEnum.returnId.EmEsperaParaValidacao,
        idHub: null,
      };
    });
    // callback();
    if (newFiles.length > 0) {
      dispatch(ListaActions.patchListaStatusRequest(newFiles));
    }
  };

  const sendToCsv = (files, user) => {
    /* const newFiles = files
      .filter((file) => file.error !== true)
      .map((file) => file.base64);

    const params = {
      codigoContratante: user?.codigoContratante,
      idUsuarioLogado: user?.idUsuarioLogado,
      newFiles,
    };
    if (newFiles.length > 0) {
      dispatch(ListaActions.importarLoteCsvRequest(params));
    } */
    setTimeout(() => history.go(0), 1500);
  };

  const sendToProcessamento = (files) => {
    const newFiles = files.map((file) => {
      return {
        idLista: file.idLista,
        statusLista: StatusListaAPIEnum.returnId.EmValidacao,
        statusExecucao: StatusExecucaoEnum.returnId.EmEsperaParaProcessamento,
        idHub: null,
      };
    });

    // callback();

    if (newFiles.length > 0)
      dispatch(ListaActions.patchListaStatusRequest(newFiles));
  };

  const sendValidacaoTransferencia = (files) => {
    const newFiles = files.map((file) => {
      return {
        idLista: file.idLista,
        descricao: file.descricao,
      };
    });
    // callback();
    if (newFiles.length > 0) {
      dispatch(ListaActions.patchValidacaoListaTrasnferenciaRequest(newFiles));
    }
  };

  // #endregion

  return {
    // File Import
    setContentText,
    setModeloPadrao,
    setValidacao,
    handleFiles,
    setErrors,

    // File Loading
    setAfterLoading,
    handleDeleteFiles,
    connection,

    // ListasDetalhe
    setDescricao,
    setTipoEnvio,
  };
};

export default useMovimentacao;
